import React, { memo } from 'react';
import PropTypes from 'prop-types';

import useStyles from './makeStyles';

const SubmitFormWrapper = ({ children, onSubmit }) => {
  const classes = useStyles();

  return (
    <form onSubmit={onSubmit}>
      <>
        <input className={classes.hiddenInput} type="submit" />
        {children}
      </>
    </form>
  );
};

SubmitFormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default memo(SubmitFormWrapper);
